/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeliveryNoteBundleOrTourArray } from '../../models/delivery-note-bundle-or-tour-array';
import { KeyType } from '../../models/key-type';

export interface GetBundlesAndTours$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;
  lastFourBundleOrTourNumbers: string;
}

export function getBundlesAndTours(http: HttpClient, rootUrl: string, params: GetBundlesAndTours$Params, context?: HttpContext): Observable<StrictHttpResponse<DeliveryNoteBundleOrTourArray>> {
  const rb = new RequestBuilder(rootUrl, getBundlesAndTours.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('lastFourBundleOrTourNumbers', params.lastFourBundleOrTourNumbers, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeliveryNoteBundleOrTourArray>;
    })
  );
}

getBundlesAndTours.PATH = '/organization-sites/{organizationSiteKey}/consignee/bundlesAndTours/{lastFourBundleOrTourNumbers}';
